import { useQuery } from '@tanstack/react-query';
import { supabase } from '../../../lib/supabase';

interface ProviderStatus {
  provider: string;
  api_key_hint: string | null;
  is_valid: boolean;
  last_checked_at: string | null;
  metadata: Record<string, unknown>;
}

export function useProviderStatus() {
  return useQuery<ProviderStatus[]>({
    queryKey: ['api-costs', 'provider-status'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('api_provider_status')
        .select('*');
      if (error) throw error;
      return data || [];
    },
    refetchInterval: 60_000,
  });
}
